module.exports = __webpack_public_path__ + "static/media/lacrosse.b041349f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/lacrosse.jpg
// module id = 693
// module chunks = 0